var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"spinner spinner-1"})]):_vm._e(),_c('router-view'),_c('Overlay'),_c('Timeout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }